import { BadgeCheck } from "lucide-react";
import { providerDisplayName } from "@/components/ProviderLogo";
import {
	Tooltip,
	TooltipContent,
	TooltipTrigger,
} from "@/components/ui/tooltip";
import { cn } from "@/lib/utils";

type VerifiedBadgeProps = {
	provider?: string | null;
	className?: string;
	size?: number;
};

/**
 * Twitter-style verified checkmark shown when an agent has a revenue provider
 * connected and verified. Indicates revenue numbers are confirmed via API key.
 */
export function VerifiedBadge({
	provider,
	className,
	size = 16,
}: VerifiedBadgeProps) {
	const label = provider
		? `Revenue verified via ${providerDisplayName(provider)}`
		: "Revenue verified";

	return (
		<Tooltip>
			<TooltipTrigger asChild>
				<span
					role="img"
					className={cn("inline-flex shrink-0", className)}
					aria-label={label}
				>
					<BadgeCheck
						width={size}
						height={size}
						fill="#1d9bf0"
						className="text-white"
						aria-hidden="true"
					/>
				</span>
			</TooltipTrigger>
			<TooltipContent>{label}</TooltipContent>
		</Tooltip>
	);
}
